export default __webpack_public_path__ + "static/media/Elec5.74901995.png";